import React, { useMemo } from "react"
import { v4 as uuid } from "uuid"

import type { IconDefinition } from "../types/IconData.types"

interface BaseIconProps extends React.SVGProps<SVGSVGElement> {
  icon: IconDefinition
  title?: string
  iconPathClassName?: string
}

export const BaseIcon: React.FC<BaseIconProps> = ({
  icon,
  title: customTitle,
  className,
  iconPathClassName,
  ...svgProps
}) => {
  const effectiveTitle = customTitle || icon.title || `${icon.name} Icon`
  const titleUuid = useMemo(() => uuid(), [])
  const titleId = `${icon.name
    .toLowerCase()
    .replace(/\s+/g, "-")}-title-${titleUuid}`
  return (
    <svg
      viewBox={icon.viewBox}
      preserveAspectRatio="xMidYMid meet"
      role="img"
      fill="currentColor"
      aria-labelledby={titleId}
      className={className}
      {...svgProps}

    >
      <title id={titleId}>{effectiveTitle}</title>
      {icon.paths.map((pathAttribs, index) => (
        <path key={index} 
          className={iconPathClassName}
        {...pathAttribs} />
      ))}
    </svg>
  )
}
